var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","name":"loading"}},[(_vm.gotSettings && _vm.checkedCookies && _vm.captchaReady)?_c('div',{style:({
      '--color-a': _vm.colorA,
      '--color-b': _vm.colorB,
      '--logo-url': `url('${ _vm.logo }')`
    }),attrs:{"id":"app"}},[_c('router-view')],1):_c('app-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }